// import React from "react";
// import {
//     Box, Typography, Button, CircularProgress, TextField, Chip, Checkbox,
//     Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
//     MenuItem, Select, FormControl,
// } from "@mui/material";
// import SearchIcon from '@mui/icons-material/Search';
// import CloseIcon from '@mui/icons-material/Close';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import {
//     FB, FB_DARK, FB_LIGHT, FB_MID, BG, BORDER, T1, T2,
//     G200, G300, G500, G700, G900, WHITE,
//     MIS_REPORT_TYPES,
//     btnGhostSx, btnPrimarySx, inputSx, selectSx,
// } from "./ReportDetailsConstants";
// import { fmtDate } from "./LedgerDetailsHelpers";

// // ─── Reusable checkbox-list section ──────────────────────────────────────────
// function CheckboxList({ searchText, onSearchChange, searchPlaceholder, items, selectedIds, onToggle, getItemId, getItemLabel, maxHeight = 200, loading = false }) {
//     const allSelected = items.length > 0 && selectedIds.length === items.length;
//     const someSelected = selectedIds.length > 0 && selectedIds.length < items.length;

//     return (
//         <>
//             {onSearchChange && (
//                 <TextField fullWidth size="small" placeholder={searchPlaceholder || "Search…"} value={searchText} onChange={(e) => onSearchChange(e.target.value)}
//                     sx={{ ...inputSx, mb: 1 }}
//                     InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: G500, fontSize: 16, flexShrink: 0 }} /> }}
//                 />
//             )}
//             <Box sx={{ border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden", maxHeight, overflowY: "auto" }}>
//                 {loading ? (
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1, px: 1.5, py: 1.25 }}>
//                         <CircularProgress size={14} sx={{ color: FB }} />
//                         <Typography sx={{ fontSize: 12, color: G500 }}>Loading…</Typography>
//                     </Box>
//                 ) : (
//                     <>
//                         {/* Sticky Select All row */}
//                         <Box sx={{ display: "flex", alignItems: "center", px: 1.25, py: "7px", background: FB_LIGHT, borderBottom: `1px solid ${G300}`, position: "sticky", top: 0, zIndex: 1 }}
//                             onClick={() => {
//                                 if (allSelected) {
//                                     items.forEach(item => selectedIds.includes(getItemId(item)) && onToggle(item));
//                                     onToggle("__clear__");
//                                 } else {
//                                     onToggle("__selectAll__", items);
//                                 }
//                             }}
//                             style={{ cursor: "pointer" }}
//                         >
//                             <Checkbox size="small" checked={allSelected} indeterminate={someSelected}
//                                 onClick={(e) => e.stopPropagation()}
//                                 onChange={() => {
//                                     if (allSelected) onToggle("__clear__");
//                                     else onToggle("__selectAll__", items);
//                                 }}
//                                 sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, "&.MuiCheckbox-indeterminate": { color: FB }, p: "4px" }}
//                             />
//                             <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>Select All ({items.length})</Typography>
//                         </Box>

//                         {items.length === 0 ? (
//                             <Box sx={{ px: 2, py: 2, textAlign: "center" }}>
//                                 <Typography sx={{ fontSize: 12, color: G500 }}>No items found</Typography>
//                             </Box>
//                         ) : (
//                             items.map((item) => {
//                                 const id = getItemId(item);
//                                 const isSelected = selectedIds.includes(id);
//                                 return (
//                                     <Box key={id} onClick={() => onToggle(item)}
//                                         sx={{ display: "flex", alignItems: "center", px: 1.25, py: "6px", cursor: "pointer", background: isSelected ? FB_LIGHT : "transparent", "&:hover": { background: FB_LIGHT }, borderBottom: `0.5px solid ${G300}` }}
//                                     >
//                                         <Checkbox size="small" checked={isSelected} onClick={(e) => e.stopPropagation()}
//                                             onChange={() => onToggle(item)}
//                                             sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, p: "4px" }}
//                                         />
//                                         <Typography sx={{ fontSize: 13, color: T1, fontWeight: isSelected ? 600 : 400 }}>
//                                             {getItemLabel(item)}
//                                         </Typography>
//                                     </Box>
//                                 );
//                             })
//                         )}
//                     </>
//                 )}
//             </Box>
//         </>
//     );
// }

// const VIEW_MODES = [
//     { value: "detailed", label: "Detailed" },
//     { value: "monthly", label: "Monthly" },
// ];

// // ─── Smart Filter Dialog (MIS Reports) ───────────────────────────────────────
// export default function SmartFilterDialog({
//     open, onClose,
//     // dates
//     tempFromDate, setTempFromDate, tempToDate, setTempToDate,
//     // report type
//     tempReportType, setTempReportType,
//     // view mode
//     tempViewMode, setTempViewMode,
//     // clients
//     allClients, tempClientSearchText, setTempClientSearchText,
//     tempSelectedClients, setTempSelectedClients,
//     filteredTempClients, handleTempSelectAll, handleTempDeselectAll, handleTempClientCheckbox,
//     // products
//     allProducts, filteredProducts, tempSelectedProducts, setTempSelectedProducts,
//     tempProductSearchText, setTempProductSearchText,
//     // item groups
//     allItemGroups, itemGroupsLoading, tempSelectedGroupIds, setTempSelectedGroupIds,
//     // cities
//     allCities, filteredCities, tempSelectedCities, setTempSelectedCities,
//     tempCitySearchText, setTempCitySearchText,
//     // agents
//     allAgents, filteredAgents, tempSelectedAgents, setTempSelectedAgents,
//     tempAgentSearchText, setTempAgentSearchText,
//     // group-filtered products (itemwise_sale)
//     groupProducts, filteredGroupProducts, groupProductsLoading,
//     tempGroupProductSearchText, setTempGroupProductSearchText,
//     // action
//     loading, onGetData,
// }) {
//     const showItemGroup = tempReportType === "itemwise_sale";
//     // const isCitywiseReport = ["itemwise_citywise_sale", "citywise_itemwise_sale"].includes(tempReportType);
//     const isCitywiseReport = [
//         "itemwise_citywise_sale",
//         "citywise_itemwise_sale",
//         "partywise_citywise_sale",
//         "citywise_partywise_sale"
//     ].includes(tempReportType);
//     const isAgentwiseReport = ["itemwise_agentwise_sale", "agentwise_itemwise_sale"].includes(tempReportType);
//     const isNotProductwiseReport = ["partywise_citywise_sale", "citywise_partywise_sale"].includes(tempReportType);
//     // const showClients      = !isCitywiseReport && !isAgentwiseReport;
//     const showClients = isNotProductwiseReport || (!isCitywiseReport && !isAgentwiseReport);
//     const isGetDataDisabled = loading || !tempFromDate || !tempToDate;

//     // ── Client toggle ──────────────────────────────────────────────────────
//     const handleClientToggle = (item) => {
//         if (item === "__clear__") { setTempSelectedClients([]); return; }
//         if (item === "__selectAll__" || Array.isArray(item)) {
//             const list = Array.isArray(item) ? item : filteredTempClients;
//             setTempSelectedClients(prev => [...prev, ...list.filter(c => !prev.some(s => s.id === c.id))]);
//             return;
//         }
//         handleTempClientCheckbox(item);
//     };

//     // ── Product toggle ─────────────────────────────────────────────────────
//     const handleProductToggle = (item) => {
//         if (item === "__clear__") { setTempSelectedProducts([]); return; }
//         if (item === "__selectAll__" || Array.isArray(item)) {
//             const list = Array.isArray(item) ? item : (filteredProducts || []);
//             setTempSelectedProducts(prev => [...prev, ...list.filter(p => !prev.some(s => s.id === p.id))]);
//             return;
//         }
//         setTempSelectedProducts(prev =>
//             prev.some(p => p.id === item.id) ? prev.filter(p => p.id !== item.id) : [...prev, item]
//         );
//     };

//     // ── Group toggle ───────────────────────────────────────────────────────
//     const handleGroupToggle = (item) => {
//         if (item === "__clear__") { setTempSelectedGroupIds([]); return; }
//         if (item === "__selectAll__" || Array.isArray(item)) {
//             const list = Array.isArray(item) ? item : allItemGroups;
//             setTempSelectedGroupIds(list.map(g => g.ItemGrpID));
//             return;
//         }
//         const id = item.ItemGrpID;
//         setTempSelectedGroupIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
//     };

//     return (
//         <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
//             PaperProps={{ sx: { borderRadius: "10px", border: `1px solid ${G300}`, boxShadow: "0 8px 40px rgba(0,0,0,0.12)" } }}
//         >
//             {/* ── Dialog Title ── */}
//             <DialogTitle sx={{ p: 0 }}>
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.75, borderBottom: `1px solid ${G300}` }}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                         <Box sx={{ width: 3, height: 22, background: FB, borderRadius: 2 }} />
//                         <Box>
//                             <Typography sx={{ fontSize: 14, fontWeight: 700, color: G900, lineHeight: 1 }}>MIS Report Filter</Typography>
//                             <Typography sx={{ fontSize: 11, color: G500, mt: "2px" }}>Configure Management Information System report parameters</Typography>
//                         </Box>
//                     </Box>
//                     <IconButton onClick={onClose} size="small" sx={{ color: G500, "&:hover": { background: G200 } }}>
//                         <CloseIcon sx={{ fontSize: 18 }} />
//                     </IconButton>
//                 </Box>
//             </DialogTitle>

//             {/* ── Dialog Content ── */}
//             <DialogContent sx={{ px: 2.5, pt: 2.5, pb: 1 }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

//                     {/* ── Report Type ── */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>Report Type</Typography>
//                         <FormControl fullWidth size="small">
//                             <Select value={tempReportType} onChange={(e) => setTempReportType(e.target.value)} displayEmpty IconComponent={KeyboardArrowDownIcon} sx={selectSx}
//                                 MenuProps={{ PaperProps: { sx: { borderRadius: "10px", border: `1px solid ${BORDER}`, boxShadow: "0 4px 20px rgba(24,119,242,0.12)", mt: 0.5 } } }}
//                             >
//                                 {MIS_REPORT_TYPES.map((rt) => (
//                                     <MenuItem key={rt.value} value={rt.value}
//                                         sx={{ fontSize: 13, color: T1, fontWeight: tempReportType === rt.value ? 600 : 400, background: tempReportType === rt.value ? FB_LIGHT : "transparent", "&:hover": { background: FB_LIGHT }, "&.Mui-selected": { background: FB_LIGHT, color: FB, "&:hover": { background: FB_LIGHT } }, borderRadius: "6px", mx: 0.5, my: 0.25 }}
//                                     >
//                                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                             <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: tempReportType === rt.value ? FB : BORDER, flexShrink: 0 }} />
//                                             {rt.label}
//                                         </Box>
//                                     </MenuItem>
//                                 ))}
//                             </Select>
//                         </FormControl>
//                     </Box>

//                     {/* ── View Mode ── */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>View Mode</Typography>
//                         <FormControl fullWidth size="small">
//                             <Select value={tempViewMode || "detailed"} onChange={(e) => setTempViewMode(e.target.value)} displayEmpty IconComponent={KeyboardArrowDownIcon} sx={selectSx}
//                                 MenuProps={{ PaperProps: { sx: { borderRadius: "10px", border: `1px solid ${BORDER}`, boxShadow: "0 4px 20px rgba(24,119,242,0.12)", mt: 0.5 } } }}
//                             >
//                                 {VIEW_MODES.map((vm) => (
//                                     <MenuItem key={vm.value} value={vm.value}
//                                         sx={{ fontSize: 13, color: T1, fontWeight: tempViewMode === vm.value ? 600 : 400, background: tempViewMode === vm.value ? FB_LIGHT : "transparent", "&:hover": { background: FB_LIGHT }, "&.Mui-selected": { background: FB_LIGHT, color: FB, "&:hover": { background: FB_LIGHT } }, borderRadius: "6px", mx: 0.5, my: 0.25 }}
//                                     >
//                                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                             <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: tempViewMode === vm.value ? FB : BORDER, flexShrink: 0 }} />
//                                             {vm.label}
//                                         </Box>
//                                     </MenuItem>
//                                 ))}
//                             </Select>
//                         </FormControl>
//                     </Box>

//                     {/* ── Divider ── */}
//                     <Box sx={{ height: "1px", background: BORDER, mx: -0.5 }} />

//                     {/* ── From / To Date ── */}
//                     <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
//                         <Box>
//                             <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>From Date</Typography>
//                             <TextField type="date" fullWidth size="small" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} sx={inputSx} />
//                         </Box>
//                         <Box>
//                             <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>To Date</Typography>
//                             <TextField type="date" fullWidth size="small" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} sx={inputSx} />
//                         </Box>
//                     </Box>

//                     {/* ── Item Group — only for ItemWise Sale ── */}
//                     {showItemGroup && (
//                         <Box>
//                             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
//                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
//                                     Item Group
//                                     {tempSelectedGroupIds.length > 0 && (
//                                         <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
//                                             · {tempSelectedGroupIds.length} selected
//                                         </Typography>
//                                     )}
//                                 </Typography>
//                                 {tempSelectedGroupIds.length > 0 && (
//                                     <Typography onClick={() => setTempSelectedGroupIds([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
//                                 )}
//                             </Box>
//                             <CheckboxList
//                                 items={allItemGroups}
//                                 selectedIds={tempSelectedGroupIds}
//                                 onToggle={handleGroupToggle}
//                                 getItemId={(g) => g.ItemGrpID}
//                                 getItemLabel={(g) => g.GroupName}
//                                 loading={itemGroupsLoading}
//                                 maxHeight={180}
//                             />
//                         </Box>
//                     )}

//                     {/* ── Clients (partywise & others) ── */}
//                     {showClients && (
//                         <Box>
//                             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
//                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
//                                     Clients
//                                     {tempSelectedClients.length > 0 && (
//                                         <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
//                                             · {tempSelectedClients.length} selected
//                                         </Typography>
//                                     )}
//                                 </Typography>
//                                 {tempSelectedClients.length > 0 && (
//                                     <Typography onClick={() => setTempSelectedClients([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
//                                 )}
//                             </Box>
//                             <CheckboxList
//                                 searchText={tempClientSearchText}
//                                 onSearchChange={setTempClientSearchText}
//                                 searchPlaceholder="Search clients by name or code…"
//                                 items={filteredTempClients}
//                                 selectedIds={tempSelectedClients.map(c => c.id)}
//                                 onToggle={handleClientToggle}
//                                 getItemId={(c) => c.id}
//                                 getItemLabel={(c) => c.FirmName}
//                                 maxHeight={200}
//                             />
//                         </Box>
//                     )}

//                     {/* ── Cities (citywise reports) ── */}
//                     {isCitywiseReport && (
//                         <Box>
//                             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
//                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
//                                     Cities
//                                     {tempSelectedCities.length > 0 && (
//                                         <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
//                                             · {tempSelectedCities.length} selected
//                                         </Typography>
//                                     )}
//                                 </Typography>
//                                 {tempSelectedCities.length > 0 && (
//                                     <Typography onClick={() => setTempSelectedCities([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
//                                 )}
//                             </Box>
//                             <CheckboxList
//                                 searchText={tempCitySearchText}
//                                 onSearchChange={setTempCitySearchText}
//                                 searchPlaceholder="Search cities…"
//                                 items={filteredCities || []}
//                                 selectedIds={tempSelectedCities}
//                                 onToggle={(item) => {
//                                     if (item === "__clear__") { setTempSelectedCities([]); return; }
//                                     if (item === "__selectAll__" || Array.isArray(item)) {
//                                         const list = Array.isArray(item) ? item : (filteredCities || []);
//                                         setTempSelectedCities(prev => [...new Set([...prev, ...list])]);
//                                         return;
//                                     }
//                                     setTempSelectedCities(prev =>
//                                         prev.includes(item) ? prev.filter(c => c !== item) : [...prev, item]
//                                     );
//                                 }}
//                                 getItemId={(c) => c}
//                                 getItemLabel={(c) => c}
//                                 maxHeight={200}
//                             />
//                         </Box>
//                     )}

//                     {/* ── Agents (agentwise reports) ── */}
//                     {isAgentwiseReport && (
//                         <Box>
//                             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
//                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
//                                     Agents
//                                     {tempSelectedAgents.length > 0 && (
//                                         <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
//                                             · {tempSelectedAgents.length} selected
//                                         </Typography>
//                                     )}
//                                 </Typography>
//                                 {tempSelectedAgents.length > 0 && (
//                                     <Typography onClick={() => setTempSelectedAgents([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
//                                 )}
//                             </Box>
//                             <CheckboxList
//                                 searchText={tempAgentSearchText}
//                                 onSearchChange={setTempAgentSearchText}
//                                 searchPlaceholder="Search agents…"
//                                 items={filteredAgents || []}
//                                 selectedIds={tempSelectedAgents.map(a => a.agentName)}
//                                 onToggle={(item) => {
//                                     if (item === "__clear__") { setTempSelectedAgents([]); return; }
//                                     if (item === "__selectAll__" || Array.isArray(item)) {
//                                         const list = Array.isArray(item) ? item : (filteredAgents || []);
//                                         setTempSelectedAgents(prev => [...prev, ...list.filter(a => !prev.some(s => s.agentName === a.agentName))]);
//                                         return;
//                                     }
//                                     setTempSelectedAgents(prev =>
//                                         prev.some(a => a.agentName === item.agentName)
//                                             ? prev.filter(a => a.agentName !== item.agentName)
//                                             : [...prev, item]
//                                     );
//                                 }}
//                                 getItemId={(a) => a.agentName}
//                                 getItemLabel={(a) => a.agentComm > 0 ? `${a.agentName} (${a.agentComm}%)` : a.agentName}
//                                 maxHeight={200}
//                             />
//                         </Box>
//                     )}

//                     {/* ── Products ── */}
//                     {!isNotProductwiseReport && (
//                         <Box>
//                             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
//                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
//                                     Products
//                                     {tempSelectedProducts.length > 0 && (
//                                         <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
//                                             · {tempSelectedProducts.length} selected
//                                         </Typography>
//                                     )}
//                                 </Typography>
//                                 {tempSelectedProducts.length > 0 && (
//                                     <Typography onClick={() => setTempSelectedProducts([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
//                                 )}
//                             </Box>

//                             {/* Itemwise Sale: products driven by selected item group */}
//                             {showItemGroup ? (
//                                 tempSelectedGroupIds.length === 0 ? (
//                                     <Box sx={{ border: `1px solid ${G300}`, borderRadius: "8px", px: 2, py: 2, textAlign: "center" }}>
//                                         <Typography sx={{ fontSize: 12, color: G500 }}>Select an item group above to load products</Typography>
//                                     </Box>
//                                 ) : (
//                                     <CheckboxList
//                                         searchText={tempGroupProductSearchText}
//                                         onSearchChange={setTempGroupProductSearchText}
//                                         searchPlaceholder="Search products by code or description…"
//                                         items={filteredGroupProducts || []}
//                                         selectedIds={tempSelectedProducts.map(p => p.id)}
//                                         onToggle={handleProductToggle}
//                                         getItemId={(p) => p.id}
//                                         getItemLabel={(p) => p.name || p.itemCode || ""}
//                                         maxHeight={200}
//                                         loading={groupProductsLoading}
//                                     />
//                                 )
//                             ) : (
//                                 /* All other report types: show full product list */
//                                 <CheckboxList
//                                     searchText={tempProductSearchText}
//                                     onSearchChange={setTempProductSearchText}
//                                     searchPlaceholder="Search products by code or description…"
//                                     items={filteredProducts || []}
//                                     selectedIds={tempSelectedProducts.map(p => p.id)}
//                                     onToggle={handleProductToggle}
//                                     getItemId={(p) => p.id}
//                                     getItemLabel={(p) => p.name || p.itemCode || ""}
//                                     maxHeight={200}
//                                 />
//                             )}
//                         </Box>
//                     )}

//                     {/* ── Preview ── */}
//                     {tempFromDate && tempToDate && (
//                         <Box sx={{ background: FB_LIGHT, border: `1px solid ${G300}`, borderRadius: "10px", p: "10px 14px", display: "flex", flexDirection: "column", gap: "6px" }}>
//                             <Typography sx={{ fontSize: 11, fontWeight: 600, color: G500, textTransform: "uppercase", letterSpacing: ".3px" }}>Preview</Typography>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
//                                 <Chip size="small" label={activeReportTypes.find((r) => r.value === tempReportType)?.label} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />
//                                 <Chip size="small" label={VIEW_MODES.find((v) => v.value === tempViewMode)?.label || "Detailed"} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />
//                                 <Chip size="small" label={`${fmtDate(tempFromDate)} – ${fmtDate(tempToDate)}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />
//                                 {showClients && tempSelectedClients.length > 0 && <Chip size="small" label={`${tempSelectedClients.length} client${tempSelectedClients.length > 1 ? "s" : ""}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
//                                 {isCitywiseReport && tempSelectedCities.length > 0 && <Chip size="small" label={`${tempSelectedCities.length} cit${tempSelectedCities.length > 1 ? "ies" : "y"}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
//                                 {isAgentwiseReport && tempSelectedAgents.length > 0 && <Chip size="small" label={`${tempSelectedAgents.length} agent${tempSelectedAgents.length > 1 ? "s" : ""}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
//                                 {tempSelectedProducts.length > 0 && <Chip size="small" label={`${tempSelectedProducts.length} product${tempSelectedProducts.length > 1 ? "s" : ""}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
//                                 {showItemGroup && tempSelectedGroupIds.length > 0 && <Chip size="small" label={`${tempSelectedGroupIds.length} group${tempSelectedGroupIds.length > 1 ? "s" : ""}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
//                             </Box>
//                         </Box>
//                     )}
//                 </Box>
//             </DialogContent>

//             {/* ── Dialog Actions ── */}
//             <DialogActions sx={{ px: 2.5, py: 2, gap: 1 }}>
//                 <Button onClick={onClose} sx={btnGhostSx} fullWidth>Cancel</Button>
//                 <Button onClick={onGetData} disabled={isGetDataDisabled}
//                     startIcon={loading ? <CircularProgress size={13} sx={{ color: WHITE }} /> : <SearchIcon sx={{ fontSize: 15 }} />}
//                     sx={btnPrimarySx} fullWidth
//                 >
//                     Get Data
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// }








import React from "react";
import {
    Box, Typography, Button, CircularProgress, TextField, Chip, Checkbox,
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
    MenuItem, Select, FormControl,
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    FB, FB_DARK, FB_LIGHT, FB_MID, BG, BORDER, T1, T2,
    G200, G300, G500, G700, G900, WHITE,
    MIS_REPORT_TYPES,
    btnGhostSx, btnPrimarySx, inputSx, selectSx,
} from "./ReportDetailsConstants";
import { fmtDate } from "./LedgerDetailsHelpers";

// ─── Reusable checkbox-list section ──────────────────────────────────────────
function CheckboxList({ searchText, onSearchChange, searchPlaceholder, items, selectedIds, onToggle, getItemId, getItemLabel, maxHeight = 200, loading = false }) {
    const selectedInView = items.filter(item => selectedIds.includes(getItemId(item))).length;
    const allSelected = items.length > 0 && selectedInView === items.length;
    const someSelected = selectedInView > 0 && selectedInView < items.length;

    return (
        <>
            {onSearchChange && (
                <TextField fullWidth size="small" placeholder={searchPlaceholder || "Search…"} value={searchText} onChange={(e) => onSearchChange(e.target.value)}
                    sx={{ ...inputSx, mb: 1 }}
                    InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: G500, fontSize: 16, flexShrink: 0 }} /> }}
                />
            )}
            <Box sx={{ border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden", maxHeight, overflowY: "auto" }}>
                {loading ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, px: 1.5, py: 1.25 }}>
                        <CircularProgress size={14} sx={{ color: FB }} />
                        <Typography sx={{ fontSize: 12, color: G500 }}>Loading…</Typography>
                    </Box>
                ) : (
                    <>
                        {/* Sticky Select All row */}
                        <Box sx={{ display: "flex", alignItems: "center", px: 1.25, py: "7px", background: FB_LIGHT, borderBottom: `1px solid ${G300}`, position: "sticky", top: 0, zIndex: 1 }}
                            onClick={() => {
                                if (allSelected) {
                                    items.forEach(item => selectedIds.includes(getItemId(item)) && onToggle(item));
                                    onToggle("__clear__");
                                } else {
                                    onToggle("__selectAll__", items);
                                }
                            }}
                            style={{ cursor: "pointer" }}
                        >
                            <Checkbox size="small" checked={allSelected} indeterminate={someSelected}
                                onClick={(e) => e.stopPropagation()}
                                onChange={() => {
                                    if (allSelected) onToggle("__clear__");
                                    else onToggle("__selectAll__", items);
                                }}
                                sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, "&.MuiCheckbox-indeterminate": { color: FB }, p: "4px" }}
                            />
                            <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>Select All ({items.length})</Typography>
                        </Box>

                        {items.length === 0 ? (
                            <Box sx={{ px: 2, py: 2, textAlign: "center" }}>
                                <Typography sx={{ fontSize: 12, color: G500 }}>No items found</Typography>
                            </Box>
                        ) : (
                            items.map((item) => {
                                const id = getItemId(item);
                                const isSelected = selectedIds.includes(id);
                                return (
                                    <Box key={id} onClick={() => onToggle(item)}
                                        sx={{ display: "flex", alignItems: "center", px: 1.25, py: "6px", cursor: "pointer", background: isSelected ? FB_LIGHT : "transparent", "&:hover": { background: FB_LIGHT }, borderBottom: `0.5px solid ${G300}` }}
                                    >
                                        <Checkbox size="small" checked={isSelected} onClick={(e) => e.stopPropagation()}
                                            onChange={() => onToggle(item)}
                                            sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, p: "4px" }}
                                        />
                                        <Typography sx={{ fontSize: 13, color: T1, fontWeight: isSelected ? 600 : 400 }}>
                                            {getItemLabel(item)}
                                        </Typography>
                                    </Box>
                                );
                            })
                        )}
                    </>
                )}
            </Box>
        </>
    );
}

const VIEW_MODES = [
    { value: "detailed", label: "Detailed" },
    { value: "monthly", label: "Monthly" },
];

// ─── Smart Filter Dialog (MIS Reports) ───────────────────────────────────────
export default function SmartFilterDialog({
    open, onClose,
    // dates
    tempFromDate, setTempFromDate, tempToDate, setTempToDate,
    // report type
    tempReportType, setTempReportType,
    // report type list (optional — defaults to all MIS types for backward compatibility)
    reportTypes,
    // view mode
    tempViewMode, setTempViewMode,
    // clients
    allClients, tempClientSearchText, setTempClientSearchText,
    tempSelectedClients, setTempSelectedClients,
    filteredTempClients, handleTempSelectAll, handleTempDeselectAll, handleTempClientCheckbox,
    // special account clients for monthly graph reports
    salesAccountsClients = [], purchaseAccountsClients = [],
    // products
    allProducts, filteredProducts, tempSelectedProducts, setTempSelectedProducts,
    tempProductSearchText, setTempProductSearchText,
    // item groups
    allItemGroups, itemGroupsLoading, tempSelectedGroupIds, setTempSelectedGroupIds,
    // cities
    allCities, filteredCities, tempSelectedCities, setTempSelectedCities,
    tempCitySearchText, setTempCitySearchText,
    // agents
    allAgents, filteredAgents, tempSelectedAgents, setTempSelectedAgents,
    tempAgentSearchText, setTempAgentSearchText,
    // group-filtered products (itemwise_sale)
    groupProducts, filteredGroupProducts, groupProductsLoading,
    tempGroupProductSearchText, setTempGroupProductSearchText,
    // action
    loading, onGetData,
}) {
    const [specialClientSearch, setSpecialClientSearch] = React.useState("");
    const activeReportTypes = reportTypes || MIS_REPORT_TYPES;
    const isMonthlyGraphType = ["monthly_sales_graph", "monthly_purchase_graph"].includes(tempReportType);
    const showItemGroup = !isMonthlyGraphType && ["itemwise_sale", "itemwise_purchase"].includes(tempReportType);
    const isCitywiseReport = !isMonthlyGraphType && [
        "itemwise_citywise_sale", "citywise_itemwise_sale",
        "partywise_citywise_sale", "citywise_partywise_sale",
        "itemwise_citywise_purchase", "citywise_itemwise_purchase",
        "partywise_citywise_purchase", "citywise_partywise_purchase",
    ].includes(tempReportType);
    const isAgentwiseReport = !isMonthlyGraphType && [
        "itemwise_agentwise_sale", "agentwise_itemwise_sale",
        "itemwise_agentwise_purchase", "agentwise_itemwise_purchase",
    ].includes(tempReportType);
    const isNotProductwiseReport = [
        "partywise_citywise_sale", "citywise_partywise_sale",
        "partywise_citywise_purchase", "citywise_partywise_purchase",
    ].includes(tempReportType);
    const showClients = isMonthlyGraphType || isNotProductwiseReport || (!isCitywiseReport && !isAgentwiseReport);

    const specialClientPool = tempReportType === "monthly_sales_graph" ? salesAccountsClients : purchaseAccountsClients;
    const filteredSpecialClients = specialClientSearch.trim()
        ? specialClientPool.filter(c => (c.FirmName || "").toLowerCase().includes(specialClientSearch.toLowerCase()))
        : specialClientPool;

    const isGetDataDisabled =
        loading ||
        !tempFromDate ||
        !tempToDate ||
        (showItemGroup && tempSelectedGroupIds.length === 0) ||
        (showClients && tempSelectedClients.length === 0) ||
        (isCitywiseReport && tempSelectedCities.length === 0) ||
        (isAgentwiseReport && tempSelectedAgents.length === 0) ||
        (!isMonthlyGraphType && !isNotProductwiseReport && tempSelectedProducts.length === 0) ||
        (showItemGroup && groupProductsLoading);

    // ── Client toggle ──────────────────────────────────────────────────────
    const handleClientToggle = (item) => {
        if (item === "__clear__") { setTempSelectedClients([]); return; }
        if (item === "__selectAll__" || Array.isArray(item)) {
            const list = Array.isArray(item) ? item : filteredTempClients;
            setTempSelectedClients(prev => [...prev, ...list.filter(c => !prev.some(s => s.id === c.id))]);
            return;
        }
        handleTempClientCheckbox(item);
    };

    // ── Special client toggle (monthly graph — uses filteredSpecialClients for selectAll) ──
    const handleSpecialClientToggle = (item) => {
        if (item === "__clear__") { setTempSelectedClients([]); return; }
        if (item === "__selectAll__" || Array.isArray(item)) {
            const list = Array.isArray(item) ? item : filteredSpecialClients;
            setTempSelectedClients(prev => [...prev, ...list.filter(c => !prev.some(s => s.id === c.id))]);
            return;
        }
        handleTempClientCheckbox(item);
    };

    // ── Product toggle ─────────────────────────────────────────────────────
    const handleProductToggle = (item) => {
        if (item === "__clear__") { setTempSelectedProducts([]); return; }
        if (item === "__selectAll__" || Array.isArray(item)) {
            const list = Array.isArray(item) ? item : (filteredProducts || []);
            setTempSelectedProducts(prev => [...prev, ...list.filter(p => !prev.some(s => s.id === p.id))]);
            return;
        }
        setTempSelectedProducts(prev =>
            prev.some(p => p.id === item.id) ? prev.filter(p => p.id !== item.id) : [...prev, item]
        );
    };

    // ── Group toggle ───────────────────────────────────────────────────────
    const handleGroupToggle = (item) => {
        if (item === "__clear__") { setTempSelectedGroupIds([]); return; }
        if (item === "__selectAll__" || Array.isArray(item)) {
            const list = Array.isArray(item) ? item : allItemGroups;
            setTempSelectedGroupIds(list.map(g => g.ItemGrpID));
            return;
        }
        const id = item.ItemGrpID;
        setTempSelectedGroupIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
            PaperProps={{ sx: { borderRadius: "10px", border: `1px solid ${G300}`, boxShadow: "0 8px 40px rgba(0,0,0,0.12)" } }}
        >
            {/* ── Dialog Title ── */}
            <DialogTitle sx={{ p: 0 }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.75, borderBottom: `1px solid ${G300}` }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box sx={{ width: 3, height: 22, background: FB, borderRadius: 2 }} />
                        <Box>
                            <Typography sx={{ fontSize: 14, fontWeight: 700, color: G900, lineHeight: 1 }}>MIS Report Filter</Typography>
                            <Typography sx={{ fontSize: 11, color: G500, mt: "2px" }}>Configure Management Information System report parameters</Typography>
                        </Box>
                    </Box>
                    <IconButton onClick={onClose} size="small" sx={{ color: G500, "&:hover": { background: G200 } }}>
                        <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                </Box>
            </DialogTitle>

            {/* ── Dialog Content ── */}
            <DialogContent sx={{ px: 2.5, pt: 2.5, pb: 1, maxHeight: "70vh", overflowY: "auto" }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

                    {/* ── Report Type ── */}
                    <Box>
                        <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>Report Type</Typography>
                        <FormControl fullWidth size="small">
                            <Select disabled value={tempReportType} onChange={(e) => { setTempReportType(e.target.value); setTempSelectedClients([]); }} displayEmpty IconComponent={KeyboardArrowDownIcon} sx={selectSx}
                                MenuProps={{ PaperProps: { sx: { borderRadius: "10px", border: `1px solid ${BORDER}`, boxShadow: "0 4px 20px rgba(24,119,242,0.12)", mt: 0.5 } } }}
                            >
                                {activeReportTypes.map((rt) => (
                                    <MenuItem key={rt.value} value={rt.value}
                                        sx={{ fontSize: 13, color: T1, fontWeight: tempReportType === rt.value ? 600 : 400, background: tempReportType === rt.value ? FB_LIGHT : "transparent", "&:hover": { background: FB_LIGHT }, "&.Mui-selected": { background: FB_LIGHT, color: FB, "&:hover": { background: FB_LIGHT } }, borderRadius: "6px", mx: 0.5, my: 0.25 }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: tempReportType === rt.value ? FB : BORDER, flexShrink: 0 }} />
                                            {rt.label}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    {/* ── View Mode ── */}
                    {!isMonthlyGraphType && <Box>
                        <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>View Mode</Typography>
                        <FormControl fullWidth size="small">
                            <Select value={tempViewMode || "detailed"} onChange={(e) => setTempViewMode(e.target.value)} displayEmpty IconComponent={KeyboardArrowDownIcon} sx={selectSx}
                                MenuProps={{ PaperProps: { sx: { borderRadius: "10px", border: `1px solid ${BORDER}`, boxShadow: "0 4px 20px rgba(24,119,242,0.12)", mt: 0.5 } } }}
                            >
                                {VIEW_MODES.map((vm) => (
                                    <MenuItem key={vm.value} value={vm.value}
                                        sx={{ fontSize: 13, color: T1, fontWeight: tempViewMode === vm.value ? 600 : 400, background: tempViewMode === vm.value ? FB_LIGHT : "transparent", "&:hover": { background: FB_LIGHT }, "&.Mui-selected": { background: FB_LIGHT, color: FB, "&:hover": { background: FB_LIGHT } }, borderRadius: "6px", mx: 0.5, my: 0.25 }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: tempViewMode === vm.value ? FB : BORDER, flexShrink: 0 }} />
                                            {vm.label}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>}

                    {/* ── Divider ── */}
                    <Box sx={{ height: "1px", background: BORDER, mx: -0.5 }} />

                    {/* ── From / To Date ── */}
                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
                        <Box>
                            <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>From Date</Typography>
                            <TextField type="date" fullWidth size="small" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} sx={inputSx} />
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>To Date</Typography>
                            <TextField type="date" fullWidth size="small" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} sx={inputSx} />
                        </Box>
                    </Box>

                    {/* ── Item Group — only for ItemWise Sale ── */}
                    {showItemGroup && (
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Item Group
                                    {tempSelectedGroupIds.length > 0 && (
                                        <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
                                            · {tempSelectedGroupIds.length} selected
                                        </Typography>
                                    )}
                                </Typography>
                                {tempSelectedGroupIds.length > 0 && (
                                    <Typography onClick={() => setTempSelectedGroupIds([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
                                )}
                            </Box>
                            <CheckboxList
                                items={allItemGroups}
                                selectedIds={tempSelectedGroupIds}
                                onToggle={handleGroupToggle}
                                getItemId={(g) => g.ItemGrpID}
                                getItemLabel={(g) => g.GroupName}
                                loading={itemGroupsLoading}
                                maxHeight={180}
                            />
                        </Box>
                    )}

                    {/* ── Clients ── */}
                    {showClients && (
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Clients
                                    {tempSelectedClients.length > 0 && (
                                        <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
                                            · {tempSelectedClients.length} selected
                                        </Typography>
                                    )}
                                </Typography>
                                {tempSelectedClients.length > 0 && (
                                    <Typography onClick={() => setTempSelectedClients([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
                                )}
                            </Box>
                            {isMonthlyGraphType ? (
                                <CheckboxList
                                    searchText={specialClientSearch}
                                    onSearchChange={setSpecialClientSearch}
                                    searchPlaceholder="Search clients by name or code…"
                                    items={filteredSpecialClients}
                                    selectedIds={tempSelectedClients.map(c => c.id)}
                                    onToggle={handleSpecialClientToggle}
                                    getItemId={(c) => c.id}
                                    getItemLabel={(c) => c.FirmName}
                                    maxHeight={200}
                                />
                            ) : (
                                <CheckboxList
                                    searchText={tempClientSearchText}
                                    onSearchChange={setTempClientSearchText}
                                    searchPlaceholder="Search clients by name or code…"
                                    items={filteredTempClients}
                                    selectedIds={tempSelectedClients.map(c => c.id)}
                                    onToggle={handleClientToggle}
                                    getItemId={(c) => c.id}
                                    getItemLabel={(c) => c.FirmName}
                                    maxHeight={200}
                                />
                            )}
                        </Box>
                    )}

                    {/* ── Cities (citywise reports) ── */}
                    {isCitywiseReport && (
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Cities
                                    {tempSelectedCities.length > 0 && (
                                        <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
                                            · {tempSelectedCities.length} selected
                                        </Typography>
                                    )}
                                </Typography>
                                {tempSelectedCities.length > 0 && (
                                    <Typography onClick={() => setTempSelectedCities([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
                                )}
                            </Box>
                            <CheckboxList
                                searchText={tempCitySearchText}
                                onSearchChange={setTempCitySearchText}
                                searchPlaceholder="Search cities…"
                                items={filteredCities || []}
                                selectedIds={tempSelectedCities}
                                onToggle={(item) => {
                                    if (item === "__clear__") { setTempSelectedCities([]); return; }
                                    if (item === "__selectAll__" || Array.isArray(item)) {
                                        const list = Array.isArray(item) ? item : (filteredCities || []);
                                        setTempSelectedCities(prev => [...new Set([...prev, ...list])]);
                                        return;
                                    }
                                    setTempSelectedCities(prev =>
                                        prev.includes(item) ? prev.filter(c => c !== item) : [...prev, item]
                                    );
                                }}
                                getItemId={(c) => c}
                                getItemLabel={(c) => c}
                                maxHeight={200}
                            />
                        </Box>
                    )}

                    {/* ── Agents (agentwise reports) ── */}
                    {isAgentwiseReport && (
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Agents
                                    {tempSelectedAgents.length > 0 && (
                                        <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
                                            · {tempSelectedAgents.length} selected
                                        </Typography>
                                    )}
                                </Typography>
                                {tempSelectedAgents.length > 0 && (
                                    <Typography onClick={() => setTempSelectedAgents([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
                                )}
                            </Box>
                            <CheckboxList
                                searchText={tempAgentSearchText}
                                onSearchChange={setTempAgentSearchText}
                                searchPlaceholder="Search agents…"
                                items={filteredAgents || []}
                                selectedIds={tempSelectedAgents.map(a => a.agentName)}
                                onToggle={(item) => {
                                    if (item === "__clear__") { setTempSelectedAgents([]); return; }
                                    if (item === "__selectAll__" || Array.isArray(item)) {
                                        const list = Array.isArray(item) ? item : (filteredAgents || []);
                                        setTempSelectedAgents(prev => [...prev, ...list.filter(a => !prev.some(s => s.agentName === a.agentName))]);
                                        return;
                                    }
                                    setTempSelectedAgents(prev =>
                                        prev.some(a => a.agentName === item.agentName)
                                            ? prev.filter(a => a.agentName !== item.agentName)
                                            : [...prev, item]
                                    );
                                }}
                                getItemId={(a) => a.agentName}
                                getItemLabel={(a) => a.agentComm > 0 ? `${a.agentName} (${a.agentComm}%)` : a.agentName}
                                maxHeight={200}
                            />
                        </Box>
                    )}

                    {/* ── Products ── */}
                    {!isMonthlyGraphType && !isNotProductwiseReport && (
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Products
                                    {tempSelectedProducts.length > 0 && (
                                        <Typography component="span" sx={{ fontSize: 11, color: FB, fontWeight: 600, ml: "6px" }}>
                                            · {tempSelectedProducts.length} selected
                                        </Typography>
                                    )}
                                </Typography>
                                {tempSelectedProducts.length > 0 && (
                                    <Typography onClick={() => setTempSelectedProducts([])} sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>Clear</Typography>
                                )}
                            </Box>

                            {/* Itemwise Sale: products driven by selected item group */}
                            {showItemGroup ? (
                                tempSelectedGroupIds.length === 0 ? (
                                    <Box sx={{ border: `1px solid ${G300}`, borderRadius: "8px", px: 2, py: 2, textAlign: "center" }}>
                                        <Typography sx={{ fontSize: 12, color: G500 }}>Select an item group above to load products</Typography>
                                    </Box>
                                ) : (
                                    <CheckboxList
                                        searchText={tempGroupProductSearchText}
                                        onSearchChange={setTempGroupProductSearchText}
                                        searchPlaceholder="Search products by code or description…"
                                        items={filteredGroupProducts || []}
                                        selectedIds={tempSelectedProducts.map(p => p.id)}
                                        onToggle={handleProductToggle}
                                        getItemId={(p) => p.id}
                                        getItemLabel={(p) => p.name || p.itemCode || ""}
                                        maxHeight={200}
                                        loading={groupProductsLoading}
                                    />
                                )
                            ) : (
                                /* All other report types: show full product list */
                                <CheckboxList
                                    searchText={tempProductSearchText}
                                    onSearchChange={setTempProductSearchText}
                                    searchPlaceholder="Search products by code or description…"
                                    items={filteredProducts || []}
                                    selectedIds={tempSelectedProducts.map(p => p.id)}
                                    onToggle={handleProductToggle}
                                    getItemId={(p) => p.id}
                                    getItemLabel={(p) => p.name || p.itemCode || ""}
                                    maxHeight={200}
                                />
                            )}
                        </Box>
                    )}

                    {/* ── Preview ── */}
                    {tempFromDate && tempToDate && (
                        <Box sx={{ background: FB_LIGHT, border: `1px solid ${G300}`, borderRadius: "10px", p: "10px 14px", display: "flex", flexDirection: "column", gap: "6px" }}>
                            <Typography sx={{ fontSize: 11, fontWeight: 600, color: G500, textTransform: "uppercase", letterSpacing: ".3px" }}>Preview</Typography>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                                <Chip size="small" label={activeReportTypes.find((r) => r.value === tempReportType)?.label} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />
                                <Chip size="small" label={VIEW_MODES.find((v) => v.value === tempViewMode)?.label || "Detailed"} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />
                                <Chip size="small" label={`${fmtDate(tempFromDate)} – ${fmtDate(tempToDate)}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />
                                {showClients && tempSelectedClients.length > 0 && <Chip size="small" label={`${tempSelectedClients.length} client${tempSelectedClients.length > 1 ? "s" : ""}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
                                {isCitywiseReport && tempSelectedCities.length > 0 && <Chip size="small" label={`${tempSelectedCities.length} cit${tempSelectedCities.length > 1 ? "ies" : "y"}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
                                {isAgentwiseReport && tempSelectedAgents.length > 0 && <Chip size="small" label={`${tempSelectedAgents.length} agent${tempSelectedAgents.length > 1 ? "s" : ""}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
                                {tempSelectedProducts.length > 0 && <Chip size="small" label={`${tempSelectedProducts.length} product${tempSelectedProducts.length > 1 ? "s" : ""}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
                                {showItemGroup && tempSelectedGroupIds.length > 0 && <Chip size="small" label={`${tempSelectedGroupIds.length} group${tempSelectedGroupIds.length > 1 ? "s" : ""}`} sx={{ fontSize: 11, height: 22, background: WHITE, color: FB, border: `1px solid ${G300}` }} />}
                            </Box>
                        </Box>
                    )}
                </Box>
            </DialogContent>

            {/* ── Dialog Actions ── */}
            <DialogActions sx={{ px: 2.5, py: 2, gap: 1 }}>
                <Button onClick={onClose} sx={btnGhostSx} fullWidth>Cancel</Button>
                <Button onClick={onGetData} disabled={isGetDataDisabled}
                    startIcon={loading ? <CircularProgress size={13} sx={{ color: WHITE }} /> : <SearchIcon sx={{ fontSize: 15 }} />}
                    sx={btnPrimarySx} fullWidth
                >
                    Get Data
                </Button>
            </DialogActions>
        </Dialog>
    );
}
